var _symbol, _defs, _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _g3, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "Layer_1",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8029 6.20436L8.70848 12.3638L1.77696 8.02843C0.783823 7.40708 0.990413 5.89855 2.11375 5.57004L18.571 0.750523C19.5996 0.449033 20.553 1.41078 20.2474 2.44276L15.3785 18.8886C15.045 20.0135 13.5451 20.2145 12.9296 19.2171L8.70525 12.3649",
    stroke: "#FCFCFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#101820;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 50",
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,29a1,1,0,0,1-.81-.41l-2.12-2.92A18.66,18.66,0,0,0,15,18.25V22a1,1,0,0,1-1.6.8l-12-9a1,1,0,0,1,0-1.6l12-9A1,1,0,0,1,15,4V8.24A19,19,0,0,1,31,27v1a1,1,0,0,1-.69.95A1.12,1.12,0,0,1,30,29ZM14,16.11h.1A20.68,20.68,0,0,1,28.69,24.5l.16.21a17,17,0,0,0-15-14.6,1,1,0,0,1-.89-1V6L3.67,13,13,20V17.11a1,1,0,0,1,.33-.74A1,1,0,0,1,14,16.11Z"
  })))), /*#__PURE__*/React.createElement("symbol", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0122408 0.62958C0.011404 0.364353 0.110481 0.0779991 0.369007 0.0187559C0.609316 -0.0363131 0.871765 0.0297479 1.05895 0.216937L6.98488 6.14286C7.27416 6.43214 7.27416 6.90115 6.98488 7.19043L1.05895 13.1164C0.87176 13.3035 0.609303 13.3696 0.368989 13.3145C0.110475 13.2553 0.0114011 12.9689 0.0105955 12.7036C0.00647186 11.3462 -0.0114671 8.33663 0.0113626 7.19043C0.0383144 5.83348 0.0169194 2.11245 0.0122408 0.62958Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 841.9 595.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#61DAFB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9V78c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6V78.5c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zM421.2 430c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24 4.7 8 9.5 15.8 14.4 23.4zM420.7 163c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6 0-15.7 22.9-35.6 58.3-50.6 8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zM310 490c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6zM320.8 78.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.9,
    cy: 296.5,
    r: 45.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.5 78.1z"
  }))))), /*#__PURE__*/React.createElement("symbol", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0122408 0.62958C0.011404 0.364353 0.110481 0.0779991 0.369007 0.0187559C0.609316 -0.0363131 0.871765 0.0297479 1.05895 0.216937L6.98488 6.14286C7.27416 6.43214 7.27416 6.90115 6.98488 7.19043L1.05895 13.1164C0.87176 13.3035 0.609303 13.3696 0.368989 13.3145C0.110475 13.2553 0.0114011 12.9689 0.0105955 12.7036C0.00647186 11.3462 -0.0114671 8.33663 0.0113626 7.19043C0.0383144 5.83348 0.0169194 2.11245 0.0122408 0.62958Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3035 6.70851L14.7142 6.11925C12.1107 3.51576 7.88961 3.51576 5.28612 6.11925C2.68262 8.72275 2.68262 12.9438 5.28612 15.5473C7.88961 18.1508 12.1107 18.1508 14.7142 15.5473C16.2282 14.0333 16.8618 11.9723 16.6149 10.0004M15.3035 6.70851H11.7679M15.3035 6.70851V3.17297",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4453 11.5556C10.4453 8.48731 12.9326 6 16.0009 6C19.0691 6 21.5564 8.48731 21.5564 11.5556V14.8889C21.5564 17.9571 19.0691 20.4444 16.0009 20.4444C12.9326 20.4444 10.4453 17.9571 10.4453 14.8889V11.5556Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.66667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8911 13.7812V14.8924C24.8911 19.8016 20.9114 23.7813 16.0022 23.7813C11.093 23.7813 7.11328 19.8016 7.11328 14.8924V13.7812",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.7812V27.1146",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("symbol", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27899 9.14136C1.34039 8.134 1.37109 7.63031 1.63212 7.14586C1.87061 6.70323 2.32692 6.27388 2.78323 6.06276C3.28268 5.83169 3.85514 5.83169 5.00007 5.83169C5.4268 5.83169 5.64016 5.83169 5.84683 5.79679C6.05115 5.76229 6.25039 5.70252 6.43996 5.61885C6.63171 5.53423 6.80984 5.41678 7.1661 5.18188L7.34855 5.06159C9.46769 3.66435 10.5273 2.96573 11.4167 3.26926C11.5872 3.32746 11.7523 3.41146 11.8997 3.51506C12.6687 4.05544 12.7271 5.3127 12.8439 7.8272C12.8872 8.75826 12.9167 9.55512 12.9167 9.99836C12.9167 10.4416 12.8872 11.2385 12.8439 12.1695C12.7271 14.684 12.6687 15.9413 11.8997 16.4817C11.7523 16.5853 11.5872 16.6693 11.4167 16.7275C10.5273 17.031 9.46769 16.3324 7.34854 14.9351L7.1661 14.8148C6.80984 14.5799 6.63171 14.4625 6.43996 14.3779C6.25039 14.2942 6.05115 14.2344 5.84683 14.1999C5.64016 14.165 5.4268 14.165 5.00007 14.165C3.85514 14.165 3.28268 14.165 2.78323 13.934C2.32692 13.7228 1.87061 13.2935 1.63212 12.8509C1.37109 12.3664 1.34039 11.8627 1.27899 10.8554C1.26083 10.5573 1.25 10.267 1.25 9.99836C1.25 9.72969 1.26083 9.43937 1.27899 9.14136Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5C15 7.5 15.4167 8.25 15.4167 10C15.4167 11.75 15 12.5 15 12.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("symbol", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 50,
    rx: 25,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 24C32 26.76 29.76 29 27 29C24.24 29 22 26.76 22 24H20C20 27.53 22.61 30.43 26 30.92V34H28V30.92C31.39 30.43 34 27.53 34 24H32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 27C28.66 27 30 25.66 30 24V18C30 16.34 28.66 15 27 15C25.34 15 24 16.34 24 18V24C24 25.66 25.34 27 27 27ZM26 18C26 17.45 26.45 17 27 17C27.55 17 28 17.45 28 18V24C28 24.55 27.55 25 27 25C26.45 25 26 24.55 26 24V18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 27C28.66 27 30 25.66 30 24V18C30 16.34 28.66 15 27 15C25.34 15 24 16.34 24 18V24C24 25.66 25.34 27 27 27Z",
    fill: "black"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(15 13)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.61cd5712d08d543c89b94ebdbffc3e6d.svg";
export { ForwardRef as ReactComponent };